import {
  Component,
  AfterViewChecked,
  ViewChild,
  ElementRef,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { StripeService } from '../../../services/stripe.service';
import { StorageService } from '../../../services/storage.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { CertificateService } from '../../../services/certificate.service';
import { ToastService } from '../../../services/toast.service';
import { KeyRotationService } from '../../../services/key-rotation.service';

@Component({
  selector: 'app-key-rotation-chat',
  templateUrl: './key-rotation-chat.component.html',
  styleUrl: './key-rotation-chat.component.less',
})
export class KeyRotationChatComponent implements OnInit, AfterViewChecked {
  userInput: string = '';
  messages$: Observable<{ type: string; content: string; files: any }[]>;
  isTyping = false;
  isLoading = false;
  foundDomain = '';
  showCloseChatButton = false;
  regEx = /\b(?:https?:\/\/)?(([\w-]+\.)+[a-z]{2,})\b/;
  isVisible = false;
  subscriptionPlan: any;
  chatInitiated = false;
  showDownloadButton = false;
  chatId: string | null = null;
  isReloading = false;
  navData: any;
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  showPaymentModal = false;
  session: any; // Will hold Stripe session object with clientSecret

  constructor(
    private chatService: KeyRotationService,
    private authService: AuthService,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private route: ActivatedRoute,
    private stripeService: StripeService,
    private storageService: StorageService,
    private certificatesService: CertificateService,
    private toaster: ToastService
  ) {
    this.messages$ = this.chatService.messages$;
    const nav = this.router.getCurrentNavigation();
    this.navData = nav?.extras.state?.['data']; //{ domain: domain, certificateId: certificateId }
  }

  ngOnInit(): void {
    console.log('key-rotation-chat.component.ts [1efa93] ngOnInit: ');
    this.listenToMessages();
    // Check if we have a chatId in the route
    this.route.params.subscribe((params) => {
      const routeChatId = params['id'];
      if (routeChatId) {
        console.log('Found chatId in route:', routeChatId);
        this.chatId = routeChatId;
        this.isReloading = true;
        this.isLoading = true;

        // Reload the chat
        this.chatService.reloadChat(routeChatId).subscribe({
          next: (response) => {
            console.log('Chat reloaded successfully:', response);
            this.isReloading = false;
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Failed to reload chat:', error);
            this.isReloading = false;
            this.isLoading = false;
            // If reload fails, proceed with normal initialization
            // this.checkSubscriptions();
            this.initiateChat();
          },
        });
      } else {
        this.initiateChat();
      }
      // this.checkSubscriptions();
    });
  }
  listenToMessages() {
    // listen to messages from the chat service
    this.chatService.messages$.subscribe((messages) => {
      console.log(
        'key-rotation-chat.component.ts [1efa93] listenToMessages: ',
        messages
      );
      setTimeout(() => this.scrollToBottom(), 100);
    });
  }

  closeChat() {
    this.chatService.clearChat();
    this.router.navigate(['/certificates']);
  }
  initiateChat() {
    this.isLoading=true;
    if (!this.chatInitiated && !this.isReloading) {
      this.chatInitiated = true;
      if (!this.chatId)
        this.chatService.postMessage(null, this.navData?.domain, this.navData?.certificateId).subscribe({
          error: (error) => console.error('Failed to initialize chat:', error),
           next: (response) => {
            console.log('Chat reloaded successfully:', response);
            this.isReloading = false;
            this.isLoading = false;
          },
        });
    }
    
  }

  async checkSubscriptions() {
    let user = this.authService.getUser();
    this.subscriptionService.getSubscriptionObservable().subscribe({
      next: (response: any) => {
        this.subscriptionPlan = response;

        // TODO get the actual count of certificates
        let isLimitAvailable = this.subscriptionService.isFeatureAvailable(
          'ssl',
          this.subscriptionPlan?.certificateCount
        );
        console.log(
          'key-rotation-chat.component.ts [kishita] subscriptionPlan response: ',
          this.subscriptionPlan?.subscription_plan?.name,
          isLimitAvailable
        );
        // check if count is as expected
        if (this.subscriptionPlan && isLimitAvailable) {
          this.initiateChat();
        } else {
          this.router.navigate(['/subscription'], {
            queryParams: { url: 'chat' },
            replaceUrl: true,
          });
        }
      },
    });
  }

  ngAfterViewChecked(): void {
    // this.scrollToBottom();
  }

  handleInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.isTyping = input.value.length > 0;
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    const message = this.userInput.trim();

    if (message) {
      this.isLoading = true;
      this.scrollToBottom();
      this.chatService
        .postMessage(message, this.navData?.domain, this.navData?.certificateId)
        .subscribe({
          next: (response: any) => {
            this.isLoading = false;
            this.showCloseChatButton = response?.showCloseChatButton ?? false;
            this.showDownloadButton = response?.showDownloadButton;
            this.chatId = response?.chatId || this.chatId;
            if (response?.session) {
              // it means, open the stripe
              this.openPaymentModal(response.session);
            }
            // Only navigate if we don't already have a chatId in the route
            if (!this.route.snapshot.params['id']) {
              this.router.navigate(['/chat/rotate-keys', this.chatId]);
            }
            this.scrollToBottom();
          },
          error: () => {
            this.isLoading = false;
          },
        });
      this.userInput = '';
      this.isTyping = false;
    }
  }
  openPaymentModal(session: any) {
    this.session = session; // Set the session with clientSecret
    this.showPaymentModal = true;
  }

  closePaymentModal() {
    this.showPaymentModal = false;
  }

  handlePaymentSuccess() {
    this.showPaymentModal = false;
    this.toaster.showToast('Payment successful!', 'success');
  }

  private scrollToBottom(): void {
    console.log(
      'key-rotation-chat.component.ts [1efa93] scrollToBottom: ',
      this.chatContainer?.nativeElement?.scrollHeight,
      this.subscriptionPlan
    );
    if (!this.chatContainer?.nativeElement) return;
    try {
      this.chatContainer.nativeElement.scrollTo({
        top: this.chatContainer.nativeElement.scrollHeight,
        behavior: 'smooth',
      });
    } catch (err) {
      console.error('Scroll to bottom failed:', err);
    }
  }

  downloadCertificate(domain: string): void {
    this.certificatesService.getdownloadCertificate(domain).subscribe({
      next: (response) => {
        const anchor = document.createElement('a');
        anchor.href = response.s3Url;
        anchor.setAttribute('download', '');
        anchor.click();
        anchor.remove(); // Clean up the anchor element after clicking
      },
      error: (error) => {
        console.error('Error downloading certificate:', error);
        throw new Error(
          'Failed to download certificate. Please try again later.'
        );
      },
    });
  }
}
